import {
  Component,
  inject,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
} from '@angular/core';
import { MenuItem } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { DrawerModule } from 'primeng/drawer';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { AppConfigService } from '../../../services/app-config.service';
import { LanguageService } from '../../../services/language.service';
import { ThemeService } from '../../../services/theme.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

interface NavLink {
  label: string;
  link: string;
  exact?: boolean;
}

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    DrawerModule,
    ButtonModule,
    ToggleSwitchModule,
    FormsModule,
    CommonModule,
    RouterLink,
    RouterLinkActive,
    TranslateModule,
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent implements OnInit, OnDestroy {
  private platform = inject(PLATFORM_ID);
  isBrowser = isPlatformBrowser(this.platform);
  drawerVisible = false;

  app = inject(AppConfigService);
  langService = inject(LanguageService);
  theme = inject(ThemeService);
  private translate = inject(TranslateService);
  private langSub?: Subscription;

  /** Anclas principales de la topbar (desktop). */
  topbarLinks: NavLink[] = [
    { label: 'Módulos', link: '/modulos' },
    { label: 'Precios', link: '/precios' },
    { label: 'Soluciones', link: '/soluciones' },
  ];

  /** Lista completa de secciones para el drawer (móvil). */
  drawerLinks: NavLink[] = [];

  ngOnInit(): void {
    this.buildDrawerLinks();
    this.langSub = this.translate.onLangChange.subscribe(() =>
      this.buildDrawerLinks()
    );
  }

  ngOnDestroy(): void {
    this.langSub?.unsubscribe();
  }

  closeDrawer(): void {
    this.drawerVisible = false;
  }

  private buildDrawerLinks(): void {
    this.drawerLinks = [
      { label: this.translate.instant('nav.inicio'), link: '/', exact: true },
      { label: 'Módulos', link: '/modulos' },
      { label: 'Soluciones', link: '/soluciones' },
      { label: 'Desarrollos a medida', link: '/a-medida' },
      { label: 'Precios', link: '/precios' },
      { label: 'Ayuda', link: '/ayuda' },
      { label: this.translate.instant('nav.contacto'), link: '/contacto' },
      { label: 'Prueba 14 días', link: '/prueba-sin-compromiso' },
    ];
  }
}
